import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <h2 className="section-title">影迷热评</h2>
        <p className="section-subtitle">真实用户的追剧体验分享，听听他们怎么说</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {commentsData.map((comment) => (
            <article
              key={comment.name}
              className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={`${comment.name}的头像`}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <h3 className="text-sm font-medium text-foreground-950">{comment.name}</h3>
                  <time className="text-xs text-foreground-500">{comment.time}</time>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.content}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}